<div class="data-table" [attr.aria-busy]="loading">
  <div class="toolbar" *ngIf="searchPlaceholder || filters.length">
    <form class="search" *ngIf="searchPlaceholder" (submit)="submitSearch($event, searchInput)">
      <input #searchInput type="search" [value]="searchValue" [placeholder]="searchPlaceholder" [attr.aria-label]="searchPlaceholder" (search)="onNativeSearch($event, searchInput)" />
      <button type="submit" aria-label="Search">
        <img src="assets/icons/data-table/search.svg" alt="" width="16" height="16" />
      </button>
    </form>

    <ng-content select="[dataTableExtra]"></ng-content>

    <ng-container *ngFor="let filter of filters; trackBy: trackFilter">
      <button *ngIf="!filter.options" class="filter" type="button" (click)="filterActivate.emit(filter.id)">
        <span>{{ filter.label }}</span>
        <img *ngIf="filter.icon === 'calendar'" src="assets/icons/data-table/calendar.svg" alt="" width="18" height="18" />
      </button>

      <label *ngIf="filter.options" class="filter">
        <img *ngIf="filter.icon === 'filter'" src="assets/icons/data-table/filter.svg" alt="" width="16" height="16" />
        <select [attr.aria-label]="filter.label" [value]="filter.value || ''" (change)="onFilterChange(filter.id, $event)">
          <option value="">{{ filter.label }}</option>
          <option *ngFor="let option of filter.options" [value]="option.value">{{ option.label }}</option>
        </select>
        <img class="chevron" src="assets/icons/data-table/chevron.svg" alt="" width="10" height="6" />
      </label>
    </ng-container>
  </div>

  <div class="sheet">
    <table [attr.aria-label]="label">
      <thead>
        <tr>
          <th *ngFor="let column of columns" scope="col" [class.is-end]="column.align === 'end'">{{ column.header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td [attr.colspan]="columns.length" class="state">Loading…</td>
        </tr>
        <tr *ngIf="!loading && !rows.length">
          <td [attr.colspan]="columns.length" class="state">{{ emptyLabel }}</td>
        </tr>
        <ng-container *ngIf="!loading">
          <tr *ngFor="let row of rows">
            <td *ngFor="let column of columns" [class.is-end]="column.align === 'end'">
              <ng-container *ngIf="templateFor(column.key) as cellTemplate; else structuredCell">
                <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row, column: column }"></ng-container>
              </ng-container>
              <ng-template #structuredCell>
                <div class="stack" [class.actions]="isActionsLayout(cellsFor(row, column))" [class.is-end]="column.align === 'end'">
                  <ng-container *ngFor="let cell of cellsFor(row, column)">
                    <ng-container *ngIf="isText(cell)">
                      <a
                        *ngIf="textCell(cell).href; else plainText"
                        class="primary"
                        [class.muted]="textCell(cell).tone === 'muted'"
                        [class.strong]="textCell(cell).tone === 'strong'"
                        [href]="textCell(cell).href"
                      >
                        {{ textCell(cell).primary }}
                      </a>
                      <ng-template #plainText>
                        <span class="primary" [class.muted]="textCell(cell).tone === 'muted'" [class.strong]="textCell(cell).tone === 'strong'">{{ textCell(cell).primary }}</span>
                      </ng-template>
                      <span class="secondary" *ngIf="textCell(cell).secondary">{{ textCell(cell).secondary }}</span>
                    </ng-container>

                    <span *ngIf="isBadge(cell)" class="badge" [class.neutral]="cell.tone === 'neutral'" [class.warning]="cell.tone === 'warning'" [class.danger]="cell.tone === 'danger'">
                      <img *ngIf="!cell.tone || cell.tone === 'success'" src="assets/icons/data-table/badge-dot.svg" alt="" width="6" height="6" />
                      <span *ngIf="cell.tone && cell.tone !== 'success'" class="dot"></span>
                      {{ cell.label }}
                    </span>

                    <span *ngIf="isStatus(cell)" class="status" [class.neutral]="cell.tone === 'neutral'" [class.warning]="cell.tone === 'warning'" [class.danger]="cell.tone === 'danger'">
                      <span class="status-icon" aria-hidden="true"></span>
                      {{ cell.label }}
                    </span>

                    <ng-container *ngIf="isActions(cell)">
                      <button *ngFor="let item of cell.actions" type="button" class="action" [class.action-primary]="item.variant === 'primary'" (click)="onAction(row, item.id)">
                        {{ item.label }}
                        <img *ngIf="item.icon === 'file'" src="assets/icons/data-table/file.svg" alt="" width="14" height="14" />
                        <img *ngIf="item.icon === 'download'" src="assets/icons/data-table/download.svg" alt="" width="14" height="14" />
                      </button>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-template>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <nav class="pager" aria-label="Pagination">
    <button type="button" aria-label="Previous page" [disabled]="page <= 1" (click)="goTo(page - 1)">
      <img src="assets/icons/data-table/page-prev.svg" alt="" width="13" height="13" />
    </button>
    <button *ngFor="let pageNumber of pages" type="button" [class.active]="pageNumber === page" [attr.aria-current]="pageNumber === page ? 'page' : null" (click)="goTo(pageNumber)">
      {{ pageNumber }}
    </button>
    <button type="button" aria-label="Next page" [disabled]="page >= pageCount" (click)="goTo(page + 1)">
      <img src="assets/icons/data-table/page-next.svg" alt="" width="13" height="13" />
    </button>
  </nav>
</div>
